var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "16px",
    height: "16px",
    viewBox: "-3.75 0 16 16",
    id: "chevron-right-16px",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_140",
    d: "M-24,16a.5.5,0,0,1-.354-.146.5.5,0,0,1,0-.708L-17.207,8-24.354.854a.5.5,0,0,1,0-.708.5.5,0,0,1,.708,0l7.5,7.5a.5.5,0,0,1,0,.708l-7.5,7.5A.5.5,0,0,1-24,16Z",
    transform: "translate(24.5 0)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronicon);
export default __webpack_public_path__ + "static/media/chevronicon.8f0644834e95d17132eb91009c603b9e.svg";
export { ForwardRef as ReactComponent };